import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconWarning.tsx
const OutlinedFilledWarning = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m18-107 462-799 462 799H18Zm466.18-132q13.4 0 23.61-10.39Q518-259.78 518-273.18q0-13.4-10.39-23.11-10.39-9.71-23.79-9.71-13.4 0-23.61 9.89Q450-286.22 450-272.82q0 13.4 10.39 23.61Q470.78-239 484.18-239ZM454-348h60v-216h-60v216Z" })
});
const OutlinedWarning = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m18-107 462-799 462 799H18Zm145-84h634L480-739 163-191Zm321.18-48q13.4 0 23.61-10.39Q518-259.78 518-273.18q0-13.4-10.39-23.11-10.39-9.71-23.79-9.71-13.4 0-23.61 9.89Q450-286.22 450-272.82q0 13.4 10.39 23.61Q470.78-239 484.18-239ZM454-348h60v-216h-60v216Zm26-117Z" })
});
const RoundedFilledWarning = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M100-107q-14.48 0-24.98-6.93Q64.52-120.85 59-131q-6.17-9.6-6.58-22.38Q52-166.16 59-179l380-656q7-12 18.1-17.5 11.11-5.5 23-5.5 11.9 0 22.9 5.5 11 5.5 18 17.5l380 656q7 12.84 6.58 25.62-.41 12.78-6.58 22.38-5.7 9.75-16.11 16.87Q874.48-107 860-107H100Zm384.18-132q13.4 0 23.61-10.39Q518-259.78 518-273.18q0-13.4-10.39-23.11-10.39-9.71-23.79-9.71-13.4 0-23.61 9.89Q450-286.22 450-272.82q0 13.4 10.39 23.61Q470.78-239 484.18-239Zm0-109q12.82 0 21.32-8.63 8.5-8.62 8.5-21.37v-156q0-12.75-8.68-21.38-8.67-8.62-21.5-8.62-12.82 0-21.32 8.62-8.5 8.63-8.5 21.38v156q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63Z" })
});
const RoundedWarning = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M100-107q-14.48 0-24.98-6.93Q64.52-120.85 59-131q-6.17-9.6-6.58-22.38Q52-166.16 59-179l380-656q7-12 18.1-17.5 11.11-5.5 23-5.5 11.9 0 22.9 5.5 11 5.5 18 17.5l380 656q7 12.84 6.58 25.62-.41 12.78-6.58 22.38-5.7 9.75-16.11 16.87Q874.48-107 860-107H100Zm63-84h634L480-739 163-191Zm321.18-48q13.4 0 23.61-10.39Q518-259.78 518-273.18q0-13.4-10.39-23.11-10.39-9.71-23.79-9.71-13.4 0-23.61 9.89Q450-286.22 450-272.82q0 13.4 10.39 23.61Q470.78-239 484.18-239Zm0-109q12.82 0 21.32-8.63 8.5-8.62 8.5-21.37v-156q0-12.75-8.68-21.38-8.67-8.62-21.5-8.62-12.82 0-21.32 8.62-8.5 8.63-8.5 21.38v156q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63ZM480-465Z" })
});
const SharpFilledWarning = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m18-107 462-799 462 799H18Zm466.18-132q13.4 0 23.61-10.39Q518-259.78 518-273.18q0-13.4-10.39-23.11-10.39-9.71-23.79-9.71-13.4 0-23.61 9.89Q450-286.22 450-272.82q0 13.4 10.39 23.61Q470.78-239 484.18-239ZM454-348h60v-216h-60v216Z" })
});
const SharpWarning = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m18-107 462-799 462 799H18Zm145-84h634L480-739 163-191Zm321.18-48q13.4 0 23.61-10.39Q518-259.78 518-273.18q0-13.4-10.39-23.11-10.39-9.71-23.79-9.71-13.4 0-23.61 9.89Q450-286.22 450-272.82q0 13.4 10.39 23.61Q470.78-239 484.18-239ZM454-348h60v-216h-60v216Zm26-117Z" })
});
const componentMap = {
	outlined: OutlinedWarning,
	"outlined-fill": OutlinedFilledWarning,
	rounded: RoundedWarning,
	"rounded-fill": RoundedFilledWarning,
	sharp: SharpWarning,
	"sharp-fill": SharpFilledWarning
};
const IconWarning = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconWarning };